if (window.location.toString().includes("programs-and-degrees")) {
  //console.log('on programs and degrees page')
  document.addEventListener("DOMContentLoaded", () => {
    jQuery.fn.accordion = function() {
      return true;
    };
  });
} else {
  /*! jQuery UI - v1.12.1 - 2017-03-31
   * http://jqueryui.com
   * Copyright jQuery Foundation and other contributors; Licensed  */
  document.addEventListener("DOMContentLoaded", () => {
    !(function(a) {
      "function" == typeof define && define.amd
        ? define([
            "jquery",
            "../version",
            "../keycode",
            "../unique-id",
            "../widget"
          ], a)
        : a(jQuery);
    })(function(a) {
      return a.widget("ui.accordion", {
        version: "1.12.1",
        options: {
          active: 0,
          animate: {},
          classes: {
            "ui-accordion-header": "ui-corner-top",
            "ui-accordion-header-collapsed": "ui-corner-all",
            "ui-accordion-content": "ui-corner-bottom"
          },
          collapsible: !1,
          event: "click",
          header: "> li > :first-child, > :not(li):even",
          heightStyle: "auto",
          icons: {
            activeHeader: "ui-icon-triangle-1-s",
            header: "ui-icon-triangle-1-e"
          },
          activate: null,
          beforeActivate: null
        },
        hideProps: {
          borderTopWidth: "hide",
          borderBottomWidth: "hide",
          paddingTop: "hide",
          paddingBottom: "hide",
          height: "hide"
        },
        showProps: {
          borderTopWidth: "show",
          borderBottomWidth: "show",
          paddingTop: "show",
          paddingBottom: "show",
          height: "show"
        },
        _create: function() {
          var b = this.options;
          (this.prevShow = this.prevHide = a()),
            this._addClass("ui-accordion", "ui-widget ui-helper-reset"),
            this.element.attr("role", "tablist"),
            b.collapsible ||
              (b.active !== !1 && null != b.active) ||
              (b.active = 0),
            this._processPanels(),
            b.active < 0 && (b.active += this.headers.length),
            this._refresh();
        },
        _getCreateEventData: function() {
          return {
            header: this.active,
            panel: this.active.length ? this.active.next() : a()
          };
        },
        _createIcons: function() {
          var b,
            c,
            d = this.options.icons;
          d &&
            ((b = a("<span>")),
            this._addClass(
              b,
              "ui-accordion-header-icon",
              "ui-icon " + d.header
            ),
            b.prependTo(this.headers),
            (c = this.active.children(".ui-accordion-header-icon")),
            this._removeClass(c, d.header)
              ._addClass(c, null, d.activeHeader)
              ._addClass(this.headers, "ui-accordion-icons"));
        },
        _destroyIcons: function() {
          this._removeClass(this.headers, "ui-accordion-icons"),
            this.headers.children(".ui-accordion-header-icon").remove();
        },
        _destroy: function() {
          var a;
          this.element.removeAttr("role"),
            this.headers
              .removeAttr(
                "role aria-expanded aria-selected aria-controls tabIndex"
              )
              .removeUniqueId(),
            this._destroyIcons(),
            (a = this.headers
              .next()
              .css("display", "")
              .removeAttr("role aria-hidden aria-labelledby")
              .removeUniqueId()),
            "content" !== this.options.heightStyle && a.css("height", "");
        },
        _setOption: function(a, b) {
          return "active" === a
            ? void this._activate(b)
            : ("event" === a &&
                (this.options.event &&
                  this._off(this.headers, this.options.event),
                this._setupEvents(b)),
              this._super(a, b),
              "collapsible" !== a ||
                b ||
                this.options.active !== !1 ||
                this._activate(0),
              void (
                "icons" === a &&
                (this._destroyIcons(), b && this._createIcons())
              ));
        },
        _setOptionDisabled: function(a) {
          this._super(a),
            this.element.attr("aria-disabled", a),
            this._toggleClass(null, "ui-state-disabled", !!a),
            this._toggleClass(
              this.headers.add(this.headers.next()),
              null,
              "ui-state-disabled",
              !!a
            );
        },
        _keydown: function(b) {
          if (!b.altKey && !b.ctrlKey) {
            var c = a.ui.keyCode,
              d = this.headers.length,
              e = this.headers.index(b.target),
              f = !1;
            switch (b.keyCode) {
              case c.RIGHT:
              case c.DOWN:
                f = this.headers[(e + 1) % d];
                break;
              case c.LEFT:
              case c.UP:
                f = this.headers[(e - 1 + d) % d];
                break;
              case c.SPACE:
              case c.ENTER:
                this._eventHandler(b);
                break;
              case c.HOME:
                f = this.headers[0];
                break;
              case c.END:
                f = this.headers[d - 1];
            }
            f &&
              (a(b.target).attr("tabIndex", -1),
              a(f).attr("tabIndex", 0),
              a(f).trigger("focus"),
              b.preventDefault());
          }
        },
        _panelKeyDown: function(b) {
          b.keyCode === a.ui.keyCode.UP &&
            b.ctrlKey &&
            a(b.currentTarget)
              .prev()
              .trigger("focus");
        },
        refresh: function() {
          var b = this.options;
          this._processPanels(),
            (b.active === !1 && b.collapsible === !0) || !this.headers.length
              ? ((b.active = !1), (this.active = a()))
              : b.active === !1
              ? this._activate(0)
              : this.active.length &&
                !a.contains(this.element[0], this.active[0])
              ? this.headers.length ===
                this.headers.find(".ui-state-disabled").length
                ? ((b.active = !1), (this.active = a()))
                : this._activate(Math.max(0, b.active - 1))
              : (b.active = this.headers.index(this.active)),
            this._destroyIcons(),
            this._refresh();
        },
        _processPanels: function() {
          var a = this.headers,
            b = this.panels;
          (this.headers = this.element.find(this.options.header)),
            this._addClass(
              this.headers,
              "ui-accordion-header ui-accordion-header-collapsed",
              "ui-state-default"
            ),
            (this.panels = this.headers
              .next()
              .filter(":not(.ui-accordion-content-active)")
              .hide()),
            this._addClass(
              this.panels,
              "ui-accordion-content",
              "ui-helper-reset ui-widget-content"
            ),
            b &&
              (this._off(a.not(this.headers)), this._off(b.not(this.panels)));
        },
        _refresh: function() {
          var b,
            c = this.options,
            d = c.heightStyle,
            e = this.element.parent();
          (this.active = this._findActive(c.active)),
            this._addClass(
              this.active,
              "ui-accordion-header-active",
              "ui-state-active"
            )._removeClass(this.active, "ui-accordion-header-collapsed"),
            this._addClass(this.active.next(), "ui-accordion-content-active"),
            this.active.next().show(),
            this.headers
              .attr("role", "tab")
              .each(function() {
                var b = a(this),
                  c = b.uniqueId().attr("id"),
                  d = b.next(),
                  e = d.uniqueId().attr("id");
                b.attr("aria-controls", e), d.attr("aria-labelledby", c);
              })
              .next()
              .attr("role", "tabpanel"),
            this.headers
              .not(this.active)
              .attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
              })
              .next()
              .attr({ "aria-hidden": "true" })
              .hide(),
            this.active.length
              ? this.active
                  .attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                  })
                  .next()
                  .attr({ "aria-hidden": "false" })
              : this.headers.eq(0).attr("tabIndex", 0),
            this._createIcons(),
            this._setupEvents(c.event),
            "fill" === d
              ? ((b = e.height()),
                this.element.siblings(":visible").each(function() {
                  var c = a(this),
                    d = c.css("position");
                  "absolute" !== d && "fixed" !== d && (b -= c.outerHeight(!0));
                }),
                this.headers.each(function() {
                  b -= a(this).outerHeight(!0);
                }),
                this.headers
                  .next()
                  .each(function() {
                    a(this).height(
                      Math.max(0, b - a(this).innerHeight() + a(this).height())
                    );
                  })
                  .css("overflow", "auto"))
              : "auto" === d &&
                ((b = 0),
                this.headers
                  .next()
                  .each(function() {
                    var c = a(this).is(":visible");
                    c || a(this).show(),
                      (b = Math.max(
                        b,
                        a(this)
                          .css("height", "")
                          .height()
                      )),
                      c || a(this).hide();
                  })
                  .height(b));
        },
        _activate: function(b) {
          var c = this._findActive(b)[0];
          c !== this.active[0] &&
            ((c = c || this.active[0]),
            this._eventHandler({
              target: c,
              currentTarget: c,
              preventDefault: a.noop
            }));
        },
        _findActive: function(b) {
          return "number" == typeof b ? this.headers.eq(b) : a();
        },
        _setupEvents: function(b) {
          var c = { keydown: "_keydown" };
          b &&
            a.each(b.split(" "), function(a, b) {
              c[b] = "_eventHandler";
            }),
            this._off(this.headers.add(this.headers.next())),
            this._on(this.headers, c),
            this._on(this.headers.next(), { keydown: "_panelKeyDown" }),
            this._hoverable(this.headers),
            this._focusable(this.headers);
        },
        _eventHandler: function(b) {
          var c,
            d,
            e = this.options,
            f = this.active,
            g = a(b.currentTarget),
            h = g[0] === f[0],
            i = h && e.collapsible,
            j = i ? a() : g.next(),
            k = f.next(),
            l = {
              oldHeader: f,
              oldPanel: k,
              newHeader: i ? a() : g,
              newPanel: j
            };
          b.preventDefault(),
            (h && !e.collapsible) ||
              this._trigger("beforeActivate", b, l) === !1 ||
              ((e.active = !i && this.headers.index(g)),
              (this.active = h ? a() : g),
              this._toggle(l),
              this._removeClass(
                f,
                "ui-accordion-header-active",
                "ui-state-active"
              ),
              e.icons &&
                ((c = f.children(".ui-accordion-header-icon")),
                this._removeClass(c, null, e.icons.activeHeader)._addClass(
                  c,
                  null,
                  e.icons.header
                )),
              h ||
                (this._removeClass(
                  g,
                  "ui-accordion-header-collapsed"
                )._addClass(g, "ui-accordion-header-active", "ui-state-active"),
                e.icons &&
                  ((d = g.children(".ui-accordion-header-icon")),
                  this._removeClass(d, null, e.icons.header)._addClass(
                    d,
                    null,
                    e.icons.activeHeader
                  )),
                this._addClass(g.next(), "ui-accordion-content-active")));
        },
        _toggle: function(b) {
          var c = b.newPanel,
            d = this.prevShow.length ? this.prevShow : b.oldPanel;
          this.prevShow.add(this.prevHide).stop(!0, !0),
            (this.prevShow = c),
            (this.prevHide = d),
            this.options.animate
              ? this._animate(c, d, b)
              : (d.hide(), c.show(), this._toggleComplete(b)),
            d.attr({ "aria-hidden": "true" }),
            d
              .prev()
              .attr({ "aria-selected": "false", "aria-expanded": "false" }),
            c.length && d.length
              ? d.prev().attr({ tabIndex: -1, "aria-expanded": "false" })
              : c.length &&
                this.headers
                  .filter(function() {
                    return 0 === parseInt(a(this).attr("tabIndex"), 10);
                  })
                  .attr("tabIndex", -1),
            c
              .attr("aria-hidden", "false")
              .prev()
              .attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
              });
        },
        _animate: function(a, b, c) {
          var d,
            e,
            f,
            g = this,
            h = 0,
            i = a.css("box-sizing"),
            j = a.length && (!b.length || a.index() < b.index()),
            k = this.options.animate || {},
            l = (j && k.down) || k,
            m = function() {
              g._toggleComplete(c);
            };
          return (
            "number" == typeof l && (f = l),
            "string" == typeof l && (e = l),
            (e = e || l.easing || k.easing),
            (f = f || l.duration || k.duration),
            b.length
              ? a.length
                ? ((d = a.show().outerHeight()),
                  b.animate(this.hideProps, {
                    duration: f,
                    easing: e,
                    step: function(a, b) {
                      b.now = Math.round(a);
                    }
                  }),
                  void a.hide().animate(this.showProps, {
                    duration: f,
                    easing: e,
                    complete: m,
                    step: function(a, c) {
                      (c.now = Math.round(a)),
                        "height" !== c.prop
                          ? "content-box" === i && (h += c.now)
                          : "content" !== g.options.heightStyle &&
                            ((c.now = Math.round(d - b.outerHeight() - h)),
                            (h = 0));
                    }
                  }))
                : b.animate(this.hideProps, f, e, m)
              : a.animate(this.showProps, f, e, m)
          );
        },
        _toggleComplete: function(a) {
          var b = a.oldPanel,
            c = b.prev();
          this._removeClass(b, "ui-accordion-content-active"),
            this._removeClass(c, "ui-accordion-header-active")._addClass(
              c,
              "ui-accordion-header-collapsed"
            ),
            b.length && (b.parent()[0].className = b.parent()[0].className),
            this._trigger("activate", null, a);
        }
      });
    });
  });
};
